import { useLocation, useParams } from 'react-router-dom';
import { Nullable } from '@/ui-kit/types';
import { VerifyCodeState } from '@/bo-kit/components/VerifyAccountPage/types';

export const useVerifyCodeState = (): Nullable<VerifyCodeState> => {
    const { state } = useLocation() as { state: Nullable<VerifyCodeState> };
    const { id, code } = useParams<{ id: string; code: string }>();
    if (state) {
        return state;
    }
    if (id == undefined && code === undefined) {
        return null;
    }
    return { id, code } as VerifyCodeState;
};
